export default __webpack_public_path__ + "static/media/fan3@3x.54730c90.png";